import styled from 'styled-components';
import { Dropdown } from 'zui/Antd';

export const StyledDropDown = styled(Dropdown)`
	display: flex;
	align-items: center;
	cursor: pointer;
	margin-top: 12px;
	border-radius: 6px;
	padding: 12px 14px;
	border: 1px solid ${({ colorBorder }) => colorBorder};

	${({ collapsed }) =>
		collapsed
			? `
      /* Styles when 'collapsed' is true */
      justify-content: center;
      align-self: center;

      width: 75px;
      height: 75px;

      img {
        width: 25px !important; 
        height: 32px !important;
      }
    `
			: `
    /* Styles when 'collapsed' is false */
      img {
        width: 16px !important; 
        height: 21px !important;
       }
    `}
`;
